import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['name', 'message']

  greet() {
    // console.log(`Hello, ${this.name}!`)
    this.messageTarget.textContent = this.name
  }

  get name() {
    return this.nameTarget.value
  }
}
